/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Canceled_ReasonInputs */

const en_settings_billing_canceled_reason = /** @type {(inputs: Settings_Billing_Canceled_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Settings_Billing_Canceled_ReasonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_canceled_reason = /** @type {((inputs?: Settings_Billing_Canceled_ReasonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Canceled_ReasonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_canceled_reason(inputs)
});
export { settings_billing_canceled_reason as "settings.billing.canceled_reason" }